import { render } from "./InterfaceChatBot.vue?vue&type=template&id=82206c58&scoped=true"
import script from "./InterfaceChatBot.vue?vue&type=script&lang=js"
export * from "./InterfaceChatBot.vue?vue&type=script&lang=js"

import "./InterfaceChatBot.vue?vue&type=style&index=0&id=82206c58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82206c58"]])

export default __exports__